import { z } from "zod"
import { CompanyUsageKind, OrganizationTypeEnum } from "../companies/dtos"
import { EmployeeSchema } from "../employees/response_data"

export const WithNewCompanyIdSchema = z.object({
  _newCompanyId: z.bigint().nullish(),
})

export const LoginResponseDataSchema = z.object({
  token: z.string(),
})

export const BackofficeType = {
  None: "None",
  Admin: "Admin",
  Superadmin: "Superadmin",
} as const

export type BackofficeTypeValue = (typeof BackofficeType)[keyof typeof BackofficeType]

export function hasBackofficeAccess(backofficeType?: BackofficeTypeValue | null) {
  return backofficeType === BackofficeType.Admin || backofficeType === BackofficeType.Superadmin
}

export type OrganizationCompany = {
  id: string
  name: string
  logo: string | null
}

export type AuthEmployeeResponseData = {
  id: string
  email: string
  name: string
  locale: z.infer<typeof EmployeeSchema>["locale"]
  avatar: string | null
  isOwner: boolean
  adminId: string | undefined
  adminEmail: string | undefined
  isAdmin: boolean
  backofficeType: BackofficeTypeValue
  isManager: boolean
  role: string | null
  organizationId: string
  companyId?: string
  organizations: OrganizationCompany[]
  organization: {
    name: string
    logo: string | null
    type: keyof typeof OrganizationTypeEnum
    showCredits: boolean
    companies: OrganizationCompany[]
  }
  company?: {
    name: string
    logo: string | null
    hasWidget: boolean
    newSupportFlowEnabledAt: string | null
    usages: (keyof typeof CompanyUsageKind)[]
  }
}

export type AuthInviteResponseData = {
  name: string
  email: string
  organizationName: string
  organizationId: string
  senderName: string
  createdAt: string
}
